import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import { ref, reactive, computed } from 'vue';
import { useSdkStore } from '@/stores/sdk'
import { ElMessageBox } from 'element-plus'

import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'elementItem',
  props: {
    template: {}
  },
  setup(__props: any) {

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
const props = __props

// 计算属性：判断是否为SVG预览
const isSvgPreview = computed(() => {
    if (!props.template?.preview_url) return false;
    const url = props.template.preview_url.toLowerCase();
    return url.endsWith('.svg') || url.includes('.svg?') || url.includes('format=svg');
});
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
const useTemplate = async () => {
    if (!islogin) {
        try {
            await ElMessageBox.confirm(
                '您还未登录，请先登录后再使用模板功能',
                '登录提示',
                {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }
            )
                // 用户点击"去登录"，跳转到登录页面
                ; (window as any).openGlobalLogin?.()
        } catch {
            // 用户点击"取消"或关闭对话框，不做任何操作
            return
        }
        return
    };
    let preview_url = props.template.preview_url
    let templates = (props.template.file_urls ? props.template.file_urls : preview_url).split(',')

    for (let i = 0; i < templates.length; i++) {
        await useMaterialTemplate(templates[i])
    }
}

const useMaterialTemplate = async (item) => {
    const fileSuffix = item.split('.').pop()
    if (['jpg', 'jpeg', 'png', 'webp', 'svg'].includes(fileSuffix)) {
        desginsdk.addElement.createImageElement(item)
        return
    }
    desginsdk.designOpt.requireFile(item)
    // desginsdk.addElement.createImageElement(item)
    // 

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "template-item bg-[#F5F7FA]",
    onClick: useTemplate
  }, [
    (!isSvgPreview.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.template.preview_url + '?x-oss-process=image/resize,w_800/quality,q_80/format,webp',
          alt: "",
          class: "template-image"
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: __props.template.preview_url,
          alt: "",
          class: "template-image svg-preview"
        }, null, 8, _hoisted_2))
  ]))
}
}

})